import {
    Component,
    OnInit,
    Input,
    AfterViewInit,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
    OnDestroy,
    ElementRef,
} from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { MapService } from 'src/app/Service/map.service';
import { Location } from '@angular/common';
import { BingMaps, XYZ } from 'ol/source';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';

declare let $: any;

@Component({

    selector: 'mapInput',

    templateUrl: './mapInputComponent.html',

})


export class MapInputComponent implements OnInit {
    map: any = {};
    car: any;
    Id: string = "0";
    flon: any;
    fLat: any;
    interval: any;
    Name: string = "";
    Plak: string = "";
    speed: string = "";
    mapSatelait: boolean = false;
    isReport: boolean = false;
    layers: any = [];
    tooltipData: any;
    source: any;
    vector: any;
    IOUsage: any
    domain: any;
    carTypes: any;
    datasabt: FormGroup = this.formBuilder.group({
        azDate: new Date().valueOf(),
        taDate: new Date().valueOf(),
    });
    private bOfflineMap: boolean = (<any>window).bOfflineMap;

    private strMapUrl: string = (<any>window).strMapUrl;
    constructor(
        private el: ElementRef,
        private notifyService: NotificationService,
        private router: Router,
        private otherService: OtherService,
        private mapService: MapService,
        private route: ActivatedRoute,
        private _location: Location,
        private formBuilder: FormBuilder,
        private gurdService: GurdServiceService
    ) { }
    ngOnInit(): void {
        this.router.url.includes('/mapInput/report') ? this.isReport = true : this.isReport = false;
        setTimeout(() => {
            this.newOpenMap();
            ///نمایش همه
            this.isReport ? this.getRepData() : this.liveGetCar();


        }, 500);
        setTimeout(() => {
            this.map.on('pointermove', (e: any) => {
                if (e.dragging) {
                    //...
                    return;
                }
                var el = this.mapService.mapPointerMove(
                    this.map.getEventPixel(e.originalEvent),
                    this.map
                );
                //Handel cursor
                var pixel = this.map.getEventPixel(e.originalEvent);
                var hit = this.map.hasFeatureAtPixel(pixel);
                this.map.getViewport().style.cursor = hit ? 'pointer' : '';
            });

            this.map.on('click', (e: any) => {
                if (e.dragging) {
                    //...
                    return;
                }
                setTimeout(() => {
                    var el = this.mapService.mapPointerMove(
                        this.map.getEventPixel(e.originalEvent),
                        this.map
                    );
                    this.showData(el);
                }, 250);
            });
            this.map.getView().on('propertychange', (e: any) => {
                var tooltip = $('#map_tooltip');
                tooltip.tooltip('hide');
                this.tooltipData = null;
            });
        }, 1500);
        this.getDomain();
        this.getIOUsage();
        this.getCarTypes();

    }
    newOpenMap() {
        this.source = new VectorSource({ wrapX: false });
        this.vector = new VectorLayer({
            source: this.source,
        });

        if (this.bOfflineMap) {

            this.layers.push(

                new TileLayer({

                    source: new XYZ({

                        // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                        url: this.strMapUrl,

                        attributions: 'Map data © RayanAndishehNasr' // 

                    }),

                })

            );

        }

        else {

            const styles = [

                'AerialWithLabelsOnDemand',

            ];

            let i, ii;

            for (i = 0, ii = styles.length; i < ii; ++i) {

                this.layers.push(

                    new TileLayer({

                        visible: false,

                        preload: Infinity,

                        source: new BingMaps({

                            // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                            key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                            imagerySet: styles[i],

                        }),

                    }),

                );
            }

            this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


        }

        this.map = new Map({
            controls: defaultControls().extend([]),
            layers: this.layers,
            target: 'test',
            view: new View({
                center: olProj.fromLonLat([51.3833554, 35.6770113]),
                zoom: 13,
            }),
        });

    }
    fitMap(data?: any) {
        if (data == null) {
            data = this.car;
        }
        var maxLatitude = data.fLat;

        var maxLongitude = data.fLon;

        var minLatitude = data.fLat;
        var minLongitude = data.fLon;

        var view = this.map.getView();

        var transformedStart = this.mapService.transformCoordinates2([
            maxLongitude,
            maxLatitude,
        ]);
        var transformedEnd = this.mapService.transformCoordinates2([
            minLongitude,
            minLatitude,
        ]);

        var source = [
            Math.min(transformedStart[0], transformedEnd[0]) - 300,
            Math.min(transformedStart[1], transformedEnd[1]) - 300,
            Math.max(transformedStart[0], transformedEnd[0]) + 300,
            Math.max(transformedStart[1], transformedEnd[1]) + 300,
            // Math.min(transformedStart[0], transformedEnd[0]) - 2000,
            // Math.min(transformedStart[1], transformedEnd[1]) - 2000,
            // Math.max(transformedStart[0], transformedEnd[0]) + 2000,
            // Math.max(transformedStart[1], transformedEnd[1] + 2000)
        ];
        view.fit(source);
    }
    showData(item: any) {
        var tooltip: any;

        tooltip = $('#map_tooltip');


        tooltip.tooltip({
            html: true,
            animation: true,
            trigger: 'manual',
            placement: 'top',
        });
        tooltip.css({
            left: item.pixel[0] + 'px',
            top: item.pixel[1] - 14 + 'px',
            zindex: 1000,
        });
        if (item.featureLayer) {
            if (item.featureLayer.feature.get('data')) {


                this.tooltipData = item.featureLayer.feature.get('data').html;
                tooltip
                    .attr(
                        'data-bs-original-title',
                        item.featureLayer.feature.get('data').html
                    )

                    .tooltip('show');

                var hoverTooltip = $('#map_tooltips');
                hoverTooltip.tooltip('hide');


            }
        } else {
            tooltip.tooltip('hide');
            this.tooltipData = null;
        }

        $('#genReport').click(() => {
            this.Id = item.featureLayer.feature.get('data').Id
            $('#datePickerModal').modal('show');
            tooltip.tooltip('hide');
            var hoverTooltip = $('#map_tooltip');
            hoverTooltip.tooltip('hide');
        });
    }

    viewReport(): void {
        $('#datePickerModal').modal('hide');
        localStorage.setItem('reportDataZa', this.gurdService.encrypt(this.datasabt.controls['azDate'].value));
        localStorage.setItem('reportDataTa', this.gurdService.encrypt(this.datasabt.controls['taDate'].value));
        localStorage.setItem('unitId', this.gurdService.encrypt(this.Id[0]))
        localStorage.setItem('vehicleName', this.gurdService.encrypt(this.Id[1]))
        this.router.navigate([
            '/report/EmadadReport'
        ]);
    }

    ngOnDestroy(): void {
        clearInterval(this.interval);
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');

    }
    goBack() {
        if (this.router.url == '/mapInput/report')
            return;
        this.router.navigate(["/manageInput"]);
    }
    guid() {
        this.otherService.guid(-1);
    }
    changeTail() {

        if (this.mapSatelait == false) {
            this.layers[1].setVisible(false);

            this.layers[0].setVisible(true);
        }
        else {
            this.layers[0].setVisible(false);

            this.layers[1].setVisible(true);
        }
        this.mapSatelait = !this.mapSatelait;

    }
    search() {
        window.clearInterval(this.interval);
        this.liveGetCar();
        this.interval = setInterval(() => {
            this.liveGetCar();
        }, 30000);
    }

    searchReport() {
        window.clearInterval(this.interval);
        this.getRepData();
        this.interval = setInterval(() => {
            this.getRepData();
        }, 30000);
    }

    getRepData = async () => {
        this.mapService.removeLayerByName(`input`, this.map);
        this.mapService.removeLayerByName(`marker`, this.map);
        var iMobileDomain = document.getElementById("domain") as any;
        var carype = document.getElementById("carype") as any;

        var model = {
            iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
            strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
            iMobileDomain: iMobileDomain.value,
            iMobileType: carype.value
        };

        this.mapService.removeLayerByName(`route_point`, this.map);
        const resp1 = await axios.post(`ServiceDelivery_Status`, model);
        resp1.data = JSON.parse(resp1.data);
        if (resp1.data.ISSessionExpired == true) {
            this.otherService.removeLocalStorage();
            // this.router.navigate(['login']);
            this.router.navigate(['login'], { queryParams: { error: '110' } });

            return;
        }
        if (resp1.data == null)
            return this.notifyService.showError('بروز خطا در سامانه');

        else {
            resp1.data.forEach((el: any, i: any) => {
                setTimeout(() => {
                    var txt = this.mapService.craeteArrowTxt([el.fLon, el.fLat], `txt${i}`, `input`, el, el.strFullName);
                    this.map.addLayer(txt);
                    var marker;

                    marker = this.mapService.createMarker(
                        [el.fLon, el.fLat],
                        `${el.tiSTatus == 0 ? '../../assets/Img/cargreenMarker.png' : '../../assets/Img/redcarMarker.png'}`,
                        `marker${i}`,
                        `marker`,
                        {
                            Id: [resp1.data[i].strUnitID, resp1.data[i].strFullName],
                            html: `<div id="" class="pointer">
                                      <h5 class='text-dark'>${el.strFullName} </h5>
                                      <hr class='text-dark m-1' />

                                      <div class='justify-content-end d-flex align-items-center'>
                                      <span class=" text-secondary ms-1">${el.strVehicleNo}</span>
                                    <i class="fa fa-square-o text-secondary "></i>
                                    </div>
                                    <div class='justify-content-end d-flex align-items-center'>
                                    <span class=" text-secondary ms-1">${el.strDate}</span>
                                  <i class="fa fa-square-o text-secondary "></i>
                                  </div>
                                    <div class='justify-content-end d-flex align-items-center'>
                                    <span class=" text-secondary ms-1">${el.strTime.trim()}</span>
                                  <i class="fa fa-clock-o text-secondary "></i>
                                  </div>
                                  <div class='justify-content-end d-flex align-items-center'>
                                  <span class=" text-secondary ms-1">${el.strStatus}</span>
                                <i class="fa fa-check-circle-o text-secondary "></i>
                                </div>
                                <div class='justify-content-end d-flex align-items-center'>
                                <span class=" text-secondary ms-1">${el.strMobileDomain_strComment}</span>
                              <i class="fa fa-check-circle-o text-secondary "></i>
                              </div>
                                  <div class='justify-content-end d-flex align-items-center'>
                                  <span class=" text-secondary ms-1">${el.strMobileType_strComment}</span>
                                <i class="fa fa-fa text-secondary "></i>
                                </div>
                              <div class='justify-content-center bg-info d-flex align-items-center'>
                              <a class='btn btn-info w-100' id='genReport'>گزارش</a>
                            </div>
                                </div>`,
                        },

                    );
                    this.map.addLayer(marker);

                });
                if (resp1.data.length > 0) {
                    this.mapService.fitMap(resp1.data, this.map);
                }
            }, 300);
        }
    }

    liveGetCar = async () => {
        this.mapService.removeLayerByName(`input`, this.map);
        this.mapService.removeLayerByName(`marker`, this.map);
        var iMobileDomain = document.getElementById("domain") as any;
        var iIOUsage = document.getElementById("IOUsage") as any;
        if (iMobileDomain.value == "-1" && iIOUsage.value == "-1") {
            this.notifyService.showInfo("لطفا یکی از آیتم ها را وارد کنید", "");
            return;
        }
        var model = {
            iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
            strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
            iMobileDomain: iMobileDomain.value,
            iIOUsage: iIOUsage.value
        };
        this.mapService.removeLayerByName(`route_point`, this.map);

        const resp = await axios.post(`IO_GetIOMobileLastValue`, model);

        resp.data = JSON.parse(resp.data);

        if (resp.data.ISSessionExpired == true) {
            this.otherService.removeLocalStorage();
            // this.router.navigate(['login']);
            this.router.navigate(['login'], { queryParams: { error: '111' } });

            return;
        }
        if (resp.data == null) {
            this.notifyService.showError('بروز خطا در سامانه');
            return;
        }
        else {
            resp.data.forEach((el: any, i: any) => {
                setTimeout(() => {
                    var txt = this.mapService.craeteArrowTxt([el.fLon, el.fLat], `txt${i}`, `input`, el, el.strFullName);
                    this.map.addLayer(txt);
                    var marker;
                    if (el.strValue == 0) {
                        marker = this.mapService.createMarker(
                            [el.fLon, el.fLat],
                            "../../assets/Img/marker5.png",
                            `marker${i}`,
                            `marker`,
                            {
                                html: `<div id="" class="">
                                      <h5 class='text-dark'>${el.strFullName} </h5>
                                      <hr class='text-dark m-1' />
                                      <div class='justify-content-end d-flex align-items-center'>
                                        <span class=" text-secondary ms-1"> ${el.strMobile}</span>
                                      <i class="fa fa-phone text-secondary "></i>
                                      </div>
                                      <div class='justify-content-end d-flex align-items-center'>
                                      <span class=" text-secondary ms-1">${el.strVehicleNo}</span>
                                    <i class="fa fa-square-o text-secondary "></i>
                                    </div>
                                    <div class='justify-content-end d-flex align-items-center'>
                                    <span class=" text-secondary ms-1">${el.strTime}</span>
                                  <i class="fa fa-clock-o text-secondary "></i>
                                  </div>

                                  <div class='justify-content-end d-flex align-items-center'>
                                  <span class=" text-secondary ms-1">${el.strIOUsage_strComment}</span>
                                <i class="fa fa-fa text-secondary "></i>
                                </div>
                                  <div class='justify-content-end d-flex align-items-center'>
                                  <span class=" text-secondary ms-1">${el.strValueTitle}</span>
                                <i class="fa fa-check-circle-o text-secondary "></i>
                                </div>
                                </div>`,
                            }
                        );
                    }
                    else {
                        marker = this.mapService.createMarker(
                            [el.fLon, el.fLat],
                            "../../assets/Img/marker.png",
                            `marker${i}`,
                            `marker`
                        );
                    }
                    this.map.addLayer(marker);

                });
                if (resp.data.length > 0) {
                    this.mapService.fitMap(resp.data, this.map);
                }
            }, 300);
        }
    }
    getDomain = async () => {
        const resp = await axios.post(
            `GetMobileDomain4Report?iSystemUser=${this.gurdService.decrypt(localStorage.getItem("ID")!)}`,
            {}
        );
        this.domain = JSON.parse(resp.data);

    }

    getIOUsage = async () => {
        const resp = await axios.post(`IO_GetIOUsage`);
        this.IOUsage = JSON.parse(resp.data);
    };

    getCarTypes = async () => {
        const resp = await axios.post(`GetMobileType`);
        this.carTypes = resp.data;
    }
}
